import { TOGGLE_CHECK_ALL_RECOMMENDED_PRODUCTS } from '../../constants/action_types'

// this has a circular dependency - so needs to be defined in a different file
export const toggleCheckAllRecommendedProducts = () => dispatch => {
  dispatch({
    type: TOGGLE_CHECK_ALL_RECOMMENDED_PRODUCTS
  })
}
